import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { Product, Shop } from '@reims-local/types';
import { shopApi } from '../lib/api';

export function Home() {
  const [shop, setShop] = useState<Shop | null>(null);
  const [products, setProducts] = useState<Product[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    Promise.all([shopApi.me(), shopApi.listProducts()])
      .then(([s, p]) => {
        setShop(s.data);
        setProducts(p.data);
      })
      .catch((err) => setError((err as Error).message));
  }, []);

  if (error) return <div className="alert alert-error">{error}</div>;
  if (!shop) return <p>Chargement…</p>;

  const availableCount = products.filter((p) => p.is_available).length;
  const lowStockCount = products.filter(
    (p) => !p.is_made_to_order && p.stock <= p.stock_alert_threshold,
  ).length;

  return (
    <>
      <h2>Bonjour, {shop.name} 👋</h2>
      <div className="grid-kpi">
        <Kpi label="Produits publiés" value={availableCount} />
        <Kpi label="Produits brouillons" value={products.length - availableCount} />
        <Kpi label="Stock en alerte" value={lowStockCount} />
        <Kpi label="Statut boutique" value={shop.status} />
      </div>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Premiers pas</h3>
        <ol>
          <li>
            Complétez les informations de votre boutique (horaires, description) —{' '}
            <Link to="/settings">Paramètres</Link>
          </li>
          <li>
            Ajoutez vos premiers produits — <Link to="/products/new">Nouveau produit</Link>
          </li>
          <li>Activez la visibilité publique une fois votre catalogue prêt (bientôt).</li>
        </ol>
        <p className="muted">
          Les commandes avec retrait en magasin seront disponibles dans la prochaine mise à jour.
        </p>
      </div>
    </>
  );
}

function Kpi({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="kpi">
      <div className="kpi-label">{label}</div>
      <div className="kpi-value">{value}</div>
    </div>
  );
}
